// Detects whether a URL should be played in a <video> element or an <iframe>.
// Returns: { kind: "video" | "iframe", src: string }

const VIDEO_FILE_RE = /\.(mp4|webm|ogg|ogv|mov|m4v|m3u8|mpd)(\?|#|$)/i;

const toEmbed = (url) => {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "").toLowerCase();
    const path = u.pathname;

    // YouTube
    if (host === "youtube.com" || host === "m.youtube.com") {
      if (path === "/watch") {
        const id = u.searchParams.get("v");
        if (id) return `https://www.youtube.com/embed/${id}`;
      }
      if (path.startsWith("/embed/")) return url;
      if (path.startsWith("/shorts/")) {
        const id = path.split("/")[2];
        if (id) return `https://www.youtube.com/embed/${id}`;
      }
    }
    if (host === "youtu.be") {
      const id = path.replace(/^\//, "").split("/")[0];
      if (id) return `https://www.youtube.com/embed/${id}`;
    }

    // Vimeo
    if (host === "vimeo.com") {
      const id = path.replace(/^\//, "").split("/")[0];
      if (/^\d+$/.test(id)) return `https://player.vimeo.com/video/${id}`;
    }
    if (host === "player.vimeo.com") return url;

    // Xvideos
    if (host.endsWith("xvideos.com") || host.endsWith("xvideos2.com") || host.endsWith("xvideos4.com")) {
      if (path.startsWith("/embedframe/")) return url;
      const m = path.match(/^\/video[\.\-]?([a-z0-9]+)/i) || path.match(/^\/video\/([a-z0-9]+)/i);
      if (m && m[1]) return `https://www.xvideos.com/embedframe/${m[1]}`;
    }

    // XHamster
    if (host.endsWith("xhamster.com") || host.endsWith("xhamster.desi") || host.endsWith("xhamster2.com")) {
      if (path.startsWith("/embed/")) return url;
      const segs = path.split("/").filter(Boolean);
      // /videos/<slug>-<id>
      if (segs[0] === "videos" && segs[1]) {
        const last = segs[1].split("-").pop();
        if (last) return `https://xhamster.com/embed/${last}`;
      }
    }

    // Pornhub
    if (host.endsWith("pornhub.com") || host.endsWith("pornhubpremium.com")) {
      if (path.startsWith("/embed/")) return url;
      if (path === "/view_video.php") {
        const id = u.searchParams.get("viewkey");
        if (id) return `https://www.pornhub.com/embed/${id}`;
      }
    }

    // RedTube
    if (host.endsWith("redtube.com")) {
      if (path.startsWith("/embed/")) return url;
      const m = path.match(/^\/(\d+)/);
      if (m && m[1]) return `https://embed.redtube.com/?id=${m[1]}`;
    }

    // YouPorn
    if (host.endsWith("youporn.com")) {
      if (path.startsWith("/embed/")) return url;
      const m = path.match(/^\/watch\/(\d+)/);
      if (m && m[1]) return `https://www.youporn.com/embed/${m[1]}/`;
    }

    // SpankBang
    if (host.endsWith("spankbang.com")) {
      if (path.includes("/embed")) return url;
      const m = path.match(/^\/([a-z0-9]+)\/video\//i) || path.match(/^\/([a-z0-9]+)\/play\//i);
      if (m && m[1]) return `https://spankbang.com/${m[1]}/embed/`;
    }

    // EPorner
    if (host.endsWith("eporner.com")) {
      if (path.startsWith("/embed/")) return url;
      const m = path.match(/^\/(?:video-|hd-porn\/)?([a-z0-9]+)/i);
      if (m && m[1]) return `https://www.eporner.com/embed/${m[1]}/`;
    }

    // TNAFlix
    if (host.endsWith("tnaflix.com")) {
      if (path.includes("/embed/")) return url;
    }

    // Generic: anything that already looks like an embed URL
    if (path.includes("/embed/") || path.includes("/embedframe/") || host.startsWith("embed.")) {
      return url;
    }
  } catch (e) {
    return null;
  }
  return null;
};

export const getPlayerSource = (rawUrl) => {
  if (!rawUrl) return { kind: "video", src: "" };

  // Relative path served by our backend → always video
  if (rawUrl.startsWith("/api/") || rawUrl.startsWith("/")) {
    return { kind: "video", src: rawUrl };
  }

  // Direct video file extension → <video>
  if (VIDEO_FILE_RE.test(rawUrl)) {
    return { kind: "video", src: rawUrl };
  }

  // Try to convert to a known embed
  const embed = toEmbed(rawUrl);
  if (embed) return { kind: "iframe", src: embed };

  // Fallback: assume <video> and let the browser try
  return { kind: "video", src: rawUrl };
};
